var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconWork48Filled = function SvgIconWork48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 15.3h-3.2v-3.1c0-1.6-1.3-2.9-2.9-2.9h-6.6c-1.6 0-2.9 1.3-2.9 2.9v3.1h-3.2a5.31 5.31 0 0 0-5.3 5.3v1.7h29.4v-1.7c0-2.92-2.38-5.3-5.3-5.3Zm-12.2-2.6h5.6v2.6h-5.6v-2.6ZM25.7 29h-3.4v-3.3h-13v7.7c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3v-7.7h-13V29Z",
    fill: "current"
  })));
};
export default SvgIconWork48Filled;